// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"m9-z"};